import { Component, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { NovaIcon } from '@rds-nova/angular-icon';

import {
  TECH_SUPPORT_PHONE_NUMBER,
  ROCKET_MORTGAGE_CLOSING_TEAM_NUMBER,
} from 'src/app/shared/constants';
import { TrackedLinkDirective } from 'src/app/core/analytics/directives/tracked-link.directive';

import { FaqMenuLinkComponent } from 'src/app/features/help-faq/components/faq-menu-link/faq-menu-link.component';
import { Feature } from 'src/app/features/feature-management/enums/feature.enum';
import { selectIsFeatureEnabled } from 'src/app/features/feature-management/store/selectors/feature-flags.selectors';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store';

@Component({
  selector: 'app-help-contacts',
  templateUrl: './help-contacts.component.html',
  styleUrls: ['./help-contacts.component.scss'],
  imports: [TranslatePipe, NovaIcon, MatMenuModule, TrackedLinkDirective, FaqMenuLinkComponent],
})
export class HelpContactsComponent {
  readonly techSupportPhoneNumber = TECH_SUPPORT_PHONE_NUMBER;
  readonly documentAndLoanPhoneNumber = ROCKET_MORTGAGE_CLOSING_TEAM_NUMBER;
  private readonly store = inject(Store<AppState>);
  readonly isHelpFaqWidgetEnabled = this.store.selectSignal(selectIsFeatureEnabled(Feature.HelpFaqWidget));

  /** Builds a tel: href from a display-formatted phone number. */
  telHref(phoneNumber: string): string {
    return 'tel:' + phoneNumber.replace(/[^\d+]/g, '');
  }
}
